;(function($, undefined){

    var rnn = window.rnn;
    var isInitialised;
    var widgetQueue;

    function buildAdminUIWidget(head, body) {
        return [
            "<div class='adminUIWidget'>",
                "<div class='adminUIWidgetHeader'>",
                    head,
                "</div>",
                "<div class='adminUIWidgetBody'>",
                    body,
                "</div>",
            "</div>"
        ].join("");
    }

    function appendWidgetToAdminUI($widget) {
        var $adminUI, $adminUIToggle;

        $adminUI = $("#adminUI");
        $adminUIToggle = $("#adminUIToggle");
        if ($adminUI.length > 0) {
            $adminUI.append($widget);
            rnn.messaging.publish("adminUIWidgetUpdated");
        }
    }

    function addAdminUIWidget($widget) {
        if (isInitialised) {
            appendWidgetToAdminUI($widget);
            rnn.messaging.publish("adminWidgetAdded");
        } else {
            widgetQueue.push($widget);
        }
    }

    function appendQueuedWidgetsToAdminUI() {
        while (widgetQueue.length > 0) {
            appendWidgetToAdminUI(widgetQueue.pop());
        }
    }

    function loadAdminUI(user) {
        var $body, $adminUI, adminUICSS, $adminUIStyle, $adminUIToggle;

        $adminUI = $("#adminUI");
        if ($adminUI.length === 0) {

            adminUICSS = [
                "#adminUI {",
                    "position:          fixed;",
                    "bottom:            30px;",
                    "left:              -145px;",
                    "width:             140px;",
                    "min-width:         140px;",
                    "min-height:        30px;",
                    "border-right:      2px solid #111;",
                    "border-bottom:     2px solid #111;",
                    "background-color:  #FEFEFE;",
                    "box-shadow:        0 0 5px #111;",
                    "z-index:           2147483647;",
                "}",
                "#adminUI p,",
                "#adminUI ul,",
                "#adminUI li {",
                    "margin:            0 0 6px 0;",
                    "padding:           0;",
                    "font-size:         13px;",
                    "line-height:       1;",
                    "list-style:        none;",
                "}",
                "#adminUI a {",
                    "text-decoration:   none;",
                    "color:             #36C;",
                "}",
                "#adminUI a:hover {",
                    "border:            0 none;",
                    "text-decoration:   underline;",
                "}",
                "#adminUIToggle {",
                    "position:          absolute;",
                    "right:             -37px;",
                    "bottom:            8px;",
                    "width:             35px;",
                    "height:            30px;",
                    "border-top:        2px solid #111;",
                    "border-right:      2px solid #111;",
                    "border-bottom:     2px solid #111;",
                    "border-left:       0;",
                    "-moz-border-radius-topright:    10px;",
                    "border-top-right-radius:        10px;",
                    "-moz-border-radius-bottomright: 10px;",
                    "border-bottom-right-radius:     10px;",
                    "background-color:  #333;",
                    "box-shadow:        0 0 5px #111;",
                    "color:             #EFEFEF;",
                    "text-align:        center;",
                    "font-size:         16px;",
                    "font-weight:       bold;",
                    "line-height:       1;",
                "}",
                "#adminUIToggle:focus {",
                    "outline:           none;",
                "}",
                ".adminUIWidget {",
                    "border-top:       2px solid #111;",
                "}",
                ".adminUIWidgetHeader {",
                    "background-color:  #111;",
                    "color:             #FEFEFE;",
                    "padding:           3px 8px 5px 10px;",
                    "font-size:         13px;",
                    "font-weight:       bold;",
                    "line-height:       1.5;",
                "}",
                ".adminUIWidgetHeader label {",
                    "color:             #FEFEFE;",
                    "font-size:         13px;",
                    "font-weight:       bold;",
                    "line-height:       1.5;",
                    "margin-bottom:     0;",
                "}",
                ".adminUIWidgetBody {",
                    "margin:           10px 10px 12px",
                "}"
            ].join("");

            $adminUIStyle = $([
                "<style>",
                    adminUICSS,
                "</style>"
            ].join(""));

            $adminUI = $("<div id='adminUI'></div>");

            $adminUIToggle = $("<button id='adminUIToggle'>&gt;</button>")
            .appendTo($adminUI)
            .bind("click", function () {
                var $this, $adminUI, duration;

                $this = $(this);
                $adminUI = $("#adminUI"); // Do I need this?
                duration = 200;
                if ($adminUI.css("left") === "0px") {
                    $this.text(">");
                    $adminUI.animate({left: "-145px"}, duration);
                } else {
                    $this.text("<");
                    $adminUI.animate({left: "0px"}, duration);
                }
            }).bind('mouseenter', function () {
                rnn.messaging.publish("adminUIWidgetToggleHovered");
            });

            $body = $("body").append($adminUIStyle).append($adminUI);

            addAdminUIWidget($(buildAdminUIWidget(
                [
                    "Hi, ",
                    user.first_name ? user.first_name : user.username
                ].join(""),
                [
                    "<ul id='adminLinks'>",
                        "<li><a href='/admin/' target='_blank'>",
                            "Admin site",
                        "</a></li>",
                    "</ul>"
                ].join("")
            )));

        }
    }

    function initAdminUI() {
        widgetQueue = [];
        rnn.modules.user.get(function (user) {
            if (user.is_staff) {
                loadAdminUI(user);
                appendQueuedWidgetsToAdminUI();
                isInitialised = true;
                $("body").trigger("adminUIWidgetAdded");
            }
        });
    }

    rnn.modules.register("adminUI", {
        buildAdminUIWidget: buildAdminUIWidget,
        addAdminUIWidget: addAdminUIWidget,
        init: initAdminUI
    });

})(jQuery);